import React from 'react'
import PropTypes from 'prop-types'

import classNames from 'classnames'

import { Container } from '@scentregroup/ui'
import containerStyles from '../../../components/container.scss'
import productImpressions from '../../../helpers/analytics-utils/product-impressions'
import Pagination from './pagination'
import ProductCard from './product-card'

import style from './products-gallery.scss'

const defaultCreateProductLink = product =>
  `/products/${product.retailer.retailerCode}/${product.nameSlug}/${product.objectId}`

const ProductsGallery = ({
  products = [],
  className = undefined,
  createProductLink = defaultCreateProductLink,
  withPagination = true,
  list = 'Product Listing Page',
  ...pagination
}) => {
  productImpressions(products, list)
  return (
    <div className={classNames(style.galleryView, className)}>
      <Container
        className={classNames(containerStyles.container, style.gallery)}
        type="large"
      >
        {products.map((product, index) => (
          <ProductCard
            key={index}
            className={style.cards}
            src={product.images[0]}
            retailer={product.retailer.name}
            productName={product.name}
            price={product.price}
            salePrice={product.isDiscounted ? product.salePrice : undefined}
            link={createProductLink(product)}
            id={product.objectId}
            primaryCategory={product.primaryCategory}
            brand={product.brand}
            list={list}
            position={index + 1}
            retailerCode={product.retailer.retailerCode}
          />
        ))}
      </Container>
      {withPagination && (
        <Pagination {...pagination} className={style.pagination} />
      )}
    </div>
  )
}

ProductsGallery.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      images: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
      name: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      isDiscounted: PropTypes.bool,
      salePrice: PropTypes.number,
      objectId: PropTypes.string,
      primaryCategory: PropTypes.string,
      brand: PropTypes.string,
      nameSlug: PropTypes.string,
      retailer: PropTypes.shape({
        name: PropTypes.string.isRequired,
        retailerCode: PropTypes.string,
      }).isRequired,
    })
  ),
  className: PropTypes.string,
  withPagination: PropTypes.bool,
  createProductLink: PropTypes.func,
  list: PropTypes.string,
}

export default ProductsGallery
